import GridDistance from './distance';

/**
 * @class Cell
 */
export default class Cell {
    /**
     * @param {number} row
     * @param {number} column
     * @constructor
     */
    constructor(row, column) {
        if (row < 0) {
            throw new Error('Cell() - Row value has to be >=0');
        }
        if (column < 0) {
            throw new Error('Cell() - Column value has to be >=0');
        }

        this.row = parseInt(row, 10);
        this.column = parseInt(column, 10);
    }

    /**
     * @return {number}
     */
    getRow() {
        return this.row;
    }

    /**
     * @return {number}
     */
    getColumn() {
        return this.column;
    }

    /**
     * @param {Cell} cell
     * @return {GridDistance}
     */
    getDistance(cell) {
        return new GridDistance(
            cell.getRow() - this.getRow(),
            cell.getColumn() - this.getColumn(),
        );
    }

    /**
     * @param {GridDistance} distance
     * @return {Cell}
     */
    move(distance) {
        return new Cell(
            Math.max(0, this.getRow() + distance.getRows()),
            Math.max(0, this.getColumn() + distance.getColumns()),
        );
    }
}
